export { HomeAlt as default } from './HomeAlt';
